import * as Yup from "yup";
import { isValidPhoneNumber } from "react-phone-number-input";

export interface RegisterValues {
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
  country: string;
  address?: string;
  city?: string;
  gender: string;
  dob?: Date;
  isEntreprise?: boolean;
  entreprise_name?: string;
  entreprise_type?: string;
  countryId: string;
}
export interface UpdateValues {
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
  country: string;
  address: string;
  city: string;
  gender: string;
  dateOfBirth: Date | null;
  isEntreprise: boolean;
  entreprise_name: string;
  entreprise_type: string;
}

export const initialValues: RegisterValues = {
  firstname: "",
  lastname: "",
  email: "",
  phone: "",
  country: "",
  city: "",
  address: "",
  gender: "",
  entreprise_name: "",
  entreprise_type: "",
  countryId: "",
  isEntreprise: false,
};


export const registerValidationSchema = Yup.object().shape({
  firstname: Yup.string().required("First Name is required"),
  lastname: Yup.string().required("Last Name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  phone: Yup.string()
    .required("Phone is required")
    .test("is-valid-phone", "Invalid phone number", function (value) {
      return value ? isValidPhoneNumber(value) : false;
    }),
  country: Yup.string().required("Country is required"),
  gender: Yup.string().required("Please select your gender"),
  isEntreprise: Yup.boolean(),
  entreprise_name: Yup.string().when("isEntreprise", {
    is: true,
    then: (schema) => schema.required("Company name is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  entreprise_type: Yup.string().when("isEntreprise", {
    is: true,
    then: (schema) => schema.required("Company type is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  countryId: Yup.string().required("Country is required"),
});
export const updateValidationSchema = Yup.object().shape({
  firstname: Yup.string().required("First Name is required"),
  lastname: Yup.string().required("Last Name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  phone: Yup.string()
    .required("Phone is required")
    .test("is-valid-phone", "Invalid phone number", function (value) {
      return value ? isValidPhoneNumber(value) : false;
    }),
  country: Yup.string().required("Country is required"),
  gender: Yup.string().required("Please select your gender"),
  isEntreprise: Yup.boolean(),
  entreprise_name: Yup.string().when("isEntreprise", {
    is: true,
    then: (schema) => schema.required("Company name is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  entreprise_type: Yup.string().when("isEntreprise", {
    is: true,
    then: (schema) => schema.required("Company type is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
});
